import React, { useEffect, useState } from 'react';
import { Dropdown, MenuProps } from 'antd';

type Props = {
    onOptionClick: Function;
    options: any[];
};
const DropDownIcon = (props: Props) => {
    
    const [items, setItems] = useState<MenuProps['items']>([]);
    // const items: MenuProps['items'] = [
    //     {
    //         key: '1',
    //         label: (
    //             <li className="pointer rtl"
    //                 onClick={()=>props.onOptionClick()}
    //             >
    //                 שייך ל
    //             </li>
    //         ),
    //     },
    //     {
    //         label: 
    //             <li className="pointer rtl"
    //                 onClick={()=>props.onOptionClick()}
    //             >
    //                 העבר לתקיה
    //             </li>,
    //         key: '2',
    //     }
    // ];

    useEffect(()=> {
        if (props.options && props.options.length>0) {
            console.log('props.options', props.options);
            const newItems: MenuProps['items'] = [];
            props.options.forEach((o: any) => {
                if (!o.hide) {
                    newItems.push(
                        {
                            label:  
                                <li className="pointer rtl"
                                    onClick={()=>props.onOptionClick(o.key)}
                                >
                                    {o.label}
                                </li>,
                            key: o.key
                        }
                    )
                }
            });
            setItems(newItems);
        }
    },[])
    return (
        <Dropdown menu={{ items }}>
            <div className='act-btn-icon icon menu-hamburger pointer'></div>
        </Dropdown>
    )
}

export default DropDownIcon;